module.exports = __webpack_public_path__ + "img/amazonec2.1aa39ab0.svg";